Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const ReactPortal = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    className,
    container,
    id,
    wrapper: Wrapper = 'div'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "container", "id", "wrapper"]);

  const cssClass = (0, _classnames.default)('lfr-tooltip-scope', className);
  let content;

  if (Wrapper) {
    content = /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
      className: cssClass,
      id: id,
      ref: ref
    }, otherProps), children);
  } else if ( /*#__PURE__*/_react.default.isValidElement(children) && _react.default.Children.only(children)) {
    content = /*#__PURE__*/_react.default.cloneElement(children, {
      className: (0, _classnames.default)(cssClass, children.props.className),
      id
    });
  } // eslint-disable-next-line @liferay/portal/no-react-dom-create-portal


  return /*#__PURE__*/(0, _reactDom.createPortal)(content, container || document.body);
});

var _default = ReactPortal;
exports.default = _default;